module.exports = __webpack_public_path__ + "media/bgm.cf97441e.mp4";